import {useSelector, useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';

import {Colors} from 'redux/actions';
import useSession from 'hooks/useSession';

const useColors = () => {
	const {t} = useTranslation();
	const dispatch = useDispatch();
	const {
		colors,
		palettes,
		colorSelected,
		fetching,
		initialised,
		paletteIndex
	} = useSelector((state) => state.colors);

	const {session} = useSession();

	const validateColor = (color, count) => {
		dispatch(Colors.addColor({
			color,
			count
		}));
	}

	const saveColors = (id, name, cols, callback) => {
		if (name.trim() === "") {
			alert(t('useColors.paletteNameRequired'));
			return;
		}
		if (cols.length <= 1) {
			alert(t('useColors.oneColorRequired'));
			return;
		}
		dispatch(Colors.save({
			id,
			name,
			colors: cols,
			session
		}, callback));
	}

	const deletePalette = (id, callback) => {
		dispatch(Colors.save({
			id,
			delete: 1,
			session
		}, callback));
	}


	const setCurrentColor = (color) => {
		dispatch(Colors.selectColor(color));
	}

	const setPalettes = (palettes, callback) => {
		dispatch(Colors.set(palettes, 0, callback));
	}

	const setCurentPalette = (index) => {
		dispatch(Colors.set(palettes, index));
	}

	return {
		palettes,
		initialised,
		setPalettes,
		deletePalette,
		saveColors,
		setCurentPalette,
		setCurrent: setCurrentColor,
		color: colorSelected,
		paletteIndex,
		colors,
		fetching,
		validate: validateColor,
		has: colors.length > 0
	};
};

export default useColors;
